import type { AthenaDevtoolsBillingWebhookInspector } from "../../protocol/billing.ts";
import type { AthenaDevtoolsBillingConnectionInspector } from "../../protocol/billing.ts";
import type { ProduceBillingInspectorInput } from "./types.ts";

function isRecord(value: unknown): value is Record<string, unknown> {
	return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function nested(
	input: Record<string, unknown> | undefined,
	key: string,
): Record<string, unknown> | undefined {
	const value = input?.[key];
	return isRecord(value) ? value : undefined;
}

export function produceBillingWebhooks(
	input: ProduceBillingInspectorInput,
	connections: AthenaDevtoolsBillingConnectionInspector[],
): AthenaDevtoolsBillingWebhookInspector {
	const billing = nested(input.config, "billing");
	const ingestion = nested(billing, "ingestion");
	const webhooks = nested(ingestion, "webhooks");
	const mollie = nested(nested(webhooks, "providers"), "mollie");
	const classic = nested(mollie, "classic");
	const nextGen = nested(mollie, "nextGen");
	const ingress = input.internals?.billingProviderRegistry?.ingress;
	const publicUrl =
		typeof ingress?.classicWebhookUrl === "string"
			? ingress.classicWebhookUrl
			: typeof webhooks?.publicBaseUrl === "string"
				? webhooks.publicBaseUrl
				: null;
	const connectionId = connections.find((row) => row.id)?.id ?? null;
	const classicEnabled = classic?.enabled !== false && webhooks?.enabled !== false;
	const nextGenEnabled = nextGen?.enabled === true;
	const signingConfigured = Boolean(
		nested(nextGen, "signingSecret") ||
			typeof nextGen?.signingSecret === "string",
	);
	return {
		desired: {
			classicEnabled: Boolean(webhooks) && classicEnabled,
			connectionId,
			nextGenEnabled,
			publicUrl,
		},
		ingress: {
			bindingToken: { configured: Boolean(connectionId), kind: "secret" },
			duplicateCount: null,
			lastReceivedAt: null,
			lastRejectedAt: null,
			lastVerifiedAt: null,
			signingSecret: signingConfigured
				? { configured: true, kind: "secret" }
				: { kind: "unset" },
		},
		provider: {
			providerWebhookId: null,
			registration: "unknown",
			status: null,
			target: publicUrl,
		},
	};
}
